type TMarkup = {
    __html: string;
};

export const createMarkup = (text: string): TMarkup => ({
    __html: text,
});
